import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../App.css";

const PortfolioInfo = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <div className="about-section padding-container">
      <div className="page-wrapper">
        <div className="about-us">

          {/* Our Work, Our Pride */}
          <div className="about-4" data-aos="fade-up" data-aos-duration="1000">
            <h1>Our <span className="orange-text">Work</span> Speaks</h1>
            <p>
              At <strong>VisionBird Technologies</strong>, we transform ideas into digital experiences that inspire, engage, and deliver results. 
              Our portfolio reflects the diversity, creativity, and technical expertise that we bring to every project.
            </p>
          </div>

          {/* What We Deliver */}
          <div className="about-2" data-aos="fade-up" data-aos-duration="1000">
            <h1>What We <span className="orange-text">Deliver</span></h1>
            <p>
              We specialize in building digital solutions that combine <strong>creativity, technology, and strategy</strong>. Every project is tailored to meet client goals, strengthen their brand, and create meaningful user experiences.
            </p>
            <ul>
              <li>Branding & Graphic Design – Logos, brand identity, social media visuals, marketing collateral.</li>
              <li>UI/UX Design – Wireframes, prototypes, web & mobile app interfaces.</li>
              <li>Web Development – Responsive websites, landing pages, and full-stack applications.</li>
              <li>Mobile App Development – Native and cross-platform apps for iOS and Android.</li>
              <li>Motion Graphics & Animation – Promotional videos, explainers, logo animations.</li>
              <li>SEO & Digital Marketing – On-page optimization, content strategy, paid campaigns.</li>
            </ul>
          </div>

          {/* Featured Projects */}
          <div className="about-3" data-aos="fade-up" data-aos-duration="1000">
            <h1>Featured <span className="orange-text">Projects</span></h1>
            <ul>
              <li><strong>Branding & Design Highlights:</strong> Complete brand identities for international startups, social media campaigns, product packaging and promotional designs.</li>
              <li><strong>Web & App Development Highlights:</strong> Responsive websites, SaaS platforms, mobile applications with seamless UI/UX.</li>
              <li><strong>Animation & Motion Graphics Highlights:</strong> Animated explainer videos, promotional reels, logo animations and brand storytelling content.</li>
              <li><strong>Digital Marketing & SEO Highlights:</strong> SEO optimization for local and global businesses, content-driven campaigns, paid advertising strategies.</li>
            </ul>
          </div>

          {/* Our Approach */}
          <div className="about-5" data-aos="fade-up" data-aos-duration="1000">
            <h1>Our <span className="orange-text">Approach</span></h1>
            <ul>
              <li>Listen & Understand – Deep dive into client goals and user needs.</li>
              <li>Strategize & Design – Develop creative solutions and intuitive interfaces.</li>
              <li>Build & Optimize – Deliver fast, responsive, and scalable solutions.</li>
              <li>Support & Grow – Maintain long-term partnerships with reliable support.</li>
            </ul>
          </div>

          {/* Industries We Serve */}
          <div className="about-6" data-aos="fade-up" data-aos-duration="1000">
            <h1>Industries We <span className="orange-text">Serve</span></h1>
            <ul>
              <li>Technology & SaaS</li>
              <li>E-commerce & Retail</li>
              <li>Finance & Professional Services</li>
              <li>Healthcare & Education</li>
              <li>Media & Marketing</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PortfolioInfo;
